import * as yup from 'yup';

const isCheckType = (type) => ['technical_competency', 'functional_competency'].includes(type);
const isCoreType = (type) => ['core_competency'].includes(type);

const requiredString = (t) => (yup.string().required(t('general.message.field_required')));
const optionalString = () => (yup.string().nullable());

export const schemaTempData = ({ type, t }) => {
  const isCore = isCoreType(type);

  const textRequired = requiredString(t);
  const textOptional = optionalString(t);
  console.log('dataValidateEdit', isCore);

  return yup.object().shape({
    tempData: yup.object().shape({
      title: yup.string().required(t('general.message.field_required')),
      competency_detail: yup.array().of(
        yup.object().shape({
          competency_type: yup.string().nullable().required(t('general.message.field_required')),
          description_sub_skill: isCore ? textOptional : textRequired,
          competency_group: yup.string().nullable().required(t('general.message.field_required')),
          detail: yup.array().of(
            yup.object().shape({
              competency_level: yup.string().required(t('general.message.field_required')),
              value: yup.string().required(t('general.message.field_required')),
              performance_criteria: yup.string().required(t('general.message.field_required')),
            }),
          ),
        }),
      ),
    }),
  });
}


export const schemaData = ({ typeCompetency, t }) => {
  const isCore = isCoreType(typeCompetency);

  const textRequired = requiredString(t);
  const textOptional = optionalString(t);
  return yup.object().shape({
    data: yup.object().shape({
      title: yup.string().required(t('general.message.field_required')),
      competency_detail: yup.array().of(
        yup.object().shape({
          competency_type: yup.string().nullable().required(t('general.message.field_required')),
          description_sub_skill: isCore ? textOptional : textRequired,
          competency_group: yup.string().nullable().when([], {
            is: () => isCheckType(typeCompetency),
            then: () => yup.string().required(t('general.message.field_required')),
          }),
          detail: yup.array().of(
            yup.object().shape({
              competency_level: isCore ? textOptional : textRequired,
              value: isCore ? textOptional : textRequired,
              performance_criteria: isCore ? textOptional : textRequired,
            }),
          ),
        }),
      ),
    }),
  });
}
